const ancientGroups = {
    scottish: {
        steppe: 49.0,
        anf: 36.6, 
        whg: 14.4,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    irish: {
        steppe: 50.2, 
        anf: 35.6, 
        whg: 14.2,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    english: {
        steppe: 47.0, 
        anf: 38.2, 
        whg: 14.8,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    german: {
        steppe: 46.0,
        anf: 40.0,
        whg: 14.0,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    slovak: {
        steppe: 46.4,
        anf: 35.8,
        whg: 16.6,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    lithuanian: {
        steppe: 45.8,
        anf: 23.0,
        whg: 0,
        baltic_hg: 31.2,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    dutch: {
        steppe: 47.8,
        anf: 37.8,
        whg: 14.4,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    swedish: {
        steppe: 50.2, 
        anf: 31.8, 
        whg: 18.0,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    norwegian: {
        steppe: 49.8, 
        anf: 33.8, 
        whg: 16.4,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    north_italian: {
        steppe: 37.0,
        anf: 57.0, 
        whg: 3.9,
        baltic_hg: 0,
        iran_paleo: 1.6,
        taforalt: 0.5,
        ehg: 0
    },
    south_italian: {
        steppe: 28.37,
        anf: 60.30, 
        whg: 0.5,
        baltic_hg: 0,
        iran_paleo: 8.83,
        taforalt: 2,
        ehg: 0
    },
    breton: {
        steppe: 49.4,
        anf: 40.4, 
        whg: 10.2,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    slavic: {
        steppe: 48.6,
        anf: 34.0, 
        whg: 8.8,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 8.6
    },
    norse: {
        steppe: 54.0,
        anf: 33.8, 
        whg: 12.2,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    greek: {
        steppe: 36.6,
        anf: 57.6, 
        whg: 0.6,
        baltic_hg: 0,
        iran_paleo: 4.6,
        taforalt: 0.6,
        ehg: 0
    },
    saxon: {
        steppe: 51.6,
        anf: 35.8, 
        whg: 12.6,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    norman: {
        steppe: 49.0,
        anf: 42.8, 
        whg: 8.2,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
    french: {
        steppe: 44.0,
        anf: 46.8, 
        whg: 9.2,
        baltic_hg: 0,
        iran_paleo: 0,
        taforalt: 0,
        ehg: 0
    },
}

export default ancientGroups;